module.exports = new __parcel__URL__("onboarding.d344422b.gif").toString();